module.exports = __webpack_public_path__ + "img/8_21.21f89436.png";